import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {borderRadius, gridCG, gridRG} from "@pg-design/helpers-css";
import {CheckIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

interface IProps {
    offerAmenities: IOfferAmenityGroup[];
}

export interface IOfferAmenityGroup {
    label: string;
    amenities: ISingleAmenity[];
}

export interface ISingleAmenity {
    label: string;
    value: number;
}

export const OfferDetailAmenities = (props: IProps) => {
    const {offerAmenities} = props;
    const theme = useTheme();

    return (
        <div css={amenitiesWrapStyle} data-testid={OFFER_TEST_IDS.OFFER_VIEW.OFFER_AMENITIES_SECTION}>
            <Text as="h2" variant="headline_4" css={amenitiesHeaderStyle}>
                Udogodnienia Inwestycji
            </Text>
            <div css={amenityContainerStyle}>
                {offerAmenities.map((amenitiesGroup) => {
                    return (
                        <div key={amenitiesGroup.label} css={amenityGroupStyle}>
                            <Text as="h3" variant="body_copy_1" css={amenityGroupTitleStyle}>
                                {amenitiesGroup.label}
                            </Text>
                            <ul css={amenitiesListStyle}>
                                {amenitiesGroup.amenities.map((singleAmenity) => (
                                    <Text as="li" variant="body_copy_2" key={singleAmenity.label} css={amenitiesListItemStyle}>
                                        <CheckIcon wrapperColor={theme.colors.primary} wrapperSize="1" css={singleAmenityIconStyle} />
                                        {singleAmenity.label}
                                    </Text>
                                ))}
                            </ul>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const amenitiesWrapStyle = css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 2.4rem 2.4rem 1.6rem 2.4rem;
    ${borderRadius(4)}
    background: #fff;
`;

const amenitiesHeaderStyle = css`
    margin: 0 0 2.4rem 0;
`;

const amenityContainerStyle = (theme: Theme) => css`
    display: grid;
    grid-template-columns: repeat(1, 1fr);

    @media (min-width: ${theme.breakpoints.md}) {
        grid-template-columns: repeat(3, 1fr);
        ${gridCG(5)}
        ${gridRG(4)}
    }

    @media (min-width: ${theme.breakpoints.lg}) {
        grid-template-columns: repeat(4, 1fr);
    }
`;

const amenityGroupStyle = (theme: Theme) => css`
    margin: 0 0 1.6rem 0;

    @media (min-width: ${theme.breakpoints.md}) {
        padding: 0 2rem 0 0;
    }
`;

const amenityGroupTitleStyle = css`
    margin: 0 0 0.7rem 0;
`;

const amenitiesListStyle = css`
    list-style-type: none;
    margin: 0;
    padding: 0;
`;

const amenitiesListItemStyle = (theme: Theme) => css`
    display: flex;
    align-items: center;
    color: ${theme.colors.gray["700"]};
    margin: 0 0 0.9rem 0;
`;

const singleAmenityIconStyle = css`
    margin: 0 1.4rem 0 0;
`;
